(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-quick-add]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.product-card__add-btn');
      var originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(form.querySelector('[name="id"]').value),
          quantity: 1
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Failed');
        return res.json();
      })
      .then(function() {
        btn.textContent = 'ADDED!';
        var countEl = document.querySelector('.site-header__cart-count');
        if (countEl) {
          var current = parseInt(countEl.textContent) || 0;
          countEl.textContent = current + 1;
        }
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        form.submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
